export const Flag = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.9 5.5L13.66 4.3C13.57 3.84 13.16 3.5 12.68 3.5H5.5C4.95 3.5 4.5 3.95 4.5 4.5V19.5C4.5 20.05 4.95 20.5 5.5 20.5C6.05 20.5 6.5 20.05 6.5 19.5V13.5H12.1L12.34 14.7C12.43 15.17 12.84 15.5 13.32 15.5H18.5C19.05 15.5 19.5 15.05 19.5 14.5V6.5C19.5 5.95 19.05 5.5 18.5 5.5H13.9Z" />
  </svg>
);
